import { render, staticRenderFns } from "./ExpantionActions.vue?vue&type=template&id=35c2a86a&scoped=true&"
import script from "./ExpantionActions.vue?vue&type=script&lang=ts&"
export * from "./ExpantionActions.vue?vue&type=script&lang=ts&"
import style0 from "./ExpantionActions.vue?vue&type=style&index=0&id=35c2a86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c2a86a",
  null
  
)

export default component.exports